<app-base-app
  [state]="state"
  [static]="static"
  [itemModel]="ItemModel.Mario"
  [interactionBarConfig]="{
    showScreenshotButton: false,
    showAvailabilityButton: false,
    showLockButton: !isLunasApp,
    showPrivacyButton: !isLunasApp,
    showRefreshButton: true,
    showDuplicateButton: !isLunasApp && (isFullscreenAppInCall$ | async) === false,
    showFullScreenButton: showFullScreenButton$ | async,
    showResetButton: !isLunasApp,
    showCloseButton: !isLunasApp,
    showHelpButton: !isLunasApp
  }"
  [shouldRunAppOnMobile]="shouldRunAppOnMobile"
  [selected]="selected$ | async"
  [shouldDisableInteractions]="shouldDisableInteractions$ | async"
  [showLoadingIndicator]="(showLoadingIndicator$ | async) || (isReloading$ | async)"
  [appIcon]="appIcon$ | async"
  (refreshButtonClicked)="onReload()"
  (interactionsLockChanged)="onInteractionsLockChanges($event)"
  (privacyChanged)="onPrivacyChanged($event)"
  (deleteItem)="onDeleteItem()"
  (resetButtonClicked)="handleReset()"
  (duplicateButtonClicked)="handleDuplicate()"
>
  <div [style.width]="'100%'" [style.height]="'100%'">
    <!--
      Generated (untrusted) apps run sandboxed. Angular requires `sandbox` to be
      a STATIC attribute on <iframe> (NG0910 forbids binding it), so we branch on
      the resource type instead of binding [attr.sandbox].
    -->
    <ng-container *ngIf="(isReloading$ | async) === false">
      <iframe
        *ngIf="isGeneratedApp; else unsandboxedMario"
        #marioIFrame
        [style.width]="'100%'"
        [style.height]="'100%'"
        [src]="state.url | safeURL"
        [id]="state.marioId"
        [title]="'Mario Application'"
        allow="autoplay; fullscreen; clipboard-read; clipboard-write"
        sandbox="allow-scripts allow-same-origin"
        (load)="onMarioLoaded()"
        appIframeMouseEvents
      >
      </iframe>
      <ng-template #unsandboxedMario>
        <iframe
          #marioIFrame
          [style.width]="'100%'"
          [style.height]="'100%'"
          [src]="state.url | safeURL"
          [id]="state.marioId"
          [title]="'Mario Application'"
          allow="autoplay; fullscreen; clipboard-read; clipboard-write"
          (load)="onMarioLoaded()"
          appIframeMouseEvents
        >
        </iframe>
      </ng-template>
    </ng-container>
  </div>
</app-base-app>
